'use client';

import { SignupType } from '@/app/(intakeFormV2)/intake-v2/types';
import { useCallback, useState } from 'react';
import { useIntakeWizardContext } from '../../contexts/WizardProvider';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import { IntakeRadioGroup } from '../common/IntakeRadioGroup';
import { IntakeStepWrapper } from '../common/IntakeStepWrapper';

const SIGNUP_TYPE_OPTIONS = [
  { value: 'Myself', label: 'Myself' },
  { value: 'Myself and my family', label: 'Myself and my family' },
  { value: 'My family members', label: 'My family members' },
  {
    value: 'Others (Employer, Client, etc)',
    label: 'Others (employer, client, etc.)',
  },
];

export const SignupTypeStep = () => {
  const { state, dispatch } = useIntakeWizardContext();
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  // Read directly from wizard state
  const signupType = state.formData?.signup_type;

  const handleChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { signup_type: value as SignupType },
      });
      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (!signupType) {
        setError('Please select an option');
        return;
      }

      goToNextStep();
    },
    [signupType, goToNextStep]
  );

  return (
    <IntakeStepWrapper
      heading='Who is this membership for?'
      description='You can save more than $1,000 per additional account member. Every member gets unlimited access to all 14 Sollis centers and 24/7 virtual care.'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <IntakeRadioGroup
        name='signup_type'
        options={SIGNUP_TYPE_OPTIONS}
        value={signupType}
        onChange={handleChange}
        error={error}
      />
    </IntakeStepWrapper>
  );
};
